module.exports = __webpack_public_path__ + "img/资产.64859587.png";